// The signed-in user is kept in localStorage ("cpdata") and copied into Redux by RequireAuth
// while the routes render. Code that has to know the user before that (the contract gate,
// which wraps the routes) reads it from here.
export const getStoredUser = () => {
  try {
    const raw = localStorage.cpdata;
    return raw && raw !== "undefined" ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const logOut = () => {
  localStorage.clear();
  window.location.href = window.location.origin;
};
